'use strict';

module.exports = function (ngModule) {
    // services
    require('./services')(ngModule);
    // routes
    ngModule.config(require('./routes'));
    // controllers
    require('./controllers')(ngModule);
    // filters
    require('./filters')(ngModule);
    // directives
    require('./directives')(ngModule);
}


/** WEBPACK FOOTER **
 ** ./src/pages/index.js
 **/